import React from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Input, Modal, Row } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'

const CustomerTagForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields } = form
  const isEdit = !_.isEmpty(formData)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      form.setFieldsValue({
        name: formData.name,
        description: formData.description,
        colorHex: formData.colorHex
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields((err, values) => {
      if (err) return
      onOk({
        name: values.name.trim(),
        description: values.description.trim(),
        colorHex: values.colorHex ? values.colorHex.trim() : null
      })
    })
  }

  return (
    <Modal
      title={`${isEdit ? 'แก้ไข' : 'สร้าง'}ป้ายกำกับกลาง`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width={560}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="ชื่อป้ายกำกับ">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: 'กรุณากรอกชื่อป้ายกำกับ' }]
          })(<Input placeholder="เช่น ซาเล้ง, ร้านของเก่า" />)}
        </Form.Item>

        <Form.Item label="คำนิยาม (บังคับ)">
          {getFieldDecorator('description', {
            rules: [{ required: true, message: 'กรุณากรอกคำนิยาม' }]
          })(
            <Input.TextArea
              rows={3}
              placeholder="เช่น คนเก็บของเก่ารายย่อยที่ใช้ซาเล้ง รถเข็น หรือจักรยาน"
            />
          )}
          <div style={{ fontSize: 12, color: '#888' }}>
            คำนิยามคือสิ่งเดียวที่ทำให้ทุกร้านตีความป้ายกำกับนี้ตรงกัน
            ถ้าปล่อยกำกวม ตัวเลขที่รวมข้ามร้านจะดูเทียบกันได้ทั้งที่จริง ๆ
            ไม่ได้
          </div>
        </Form.Item>

        <Form.Item label="สี (ไม่บังคับ)">
          {getFieldDecorator('colorHex')(<Input placeholder="#324c7b" />)}
        </Form.Item>

        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'CustomerTagForm' })(CustomerTagForm)
